/* unplugin-vue-components disabled */import { render } from "./TabBarLight.vue?vue&type=template&id=78cab666&scoped=true"
import script from "./TabBarLight.vue?vue&type=script&lang=js"
export * from "./TabBarLight.vue?vue&type=script&lang=js"

import "./TabBarLight.vue?vue&type=style&index=0&id=78cab666&scoped=true&lang=scss"

import exportComponent from "E:\\贝优\\LX000864-beiXuanZhenYan-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78cab666"]])

export default __exports__